import React, { useEffect } from 'react';
// import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import { delPortal } from 'modules/portal';
//import SuccessSnackbar from 'components/molecules/Snackbar';
import SuccessSnackbar from 'components/organisms/Snackbar';

import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { createMuiTheme } from '@material-ui/core/styles';

import {
  ThemeProvider,
  StylesProvider,
  createGenerateClassName,
} from '@material-ui/styles';
import { brown } from '@material-ui/core/colors';

import Join from 'pages/Join/Join';
import FindPassword from 'pages/FindPassword';
import RegisterSuccess from 'pages/Join/RegisterSuccess';
import LoginFormContainer from 'pages/Login/LoginForm';
import MainTemplate from 'pages/templates/MainTemplate';
import Users from 'pages/Main/Users';
import ChangeInfo from 'pages/Main/ChangeInfo';
import MyWindowPortal from 'components/molecules/WindowPortal';

//컴바인 로그인
//import CombineLogin from 'pages/Login/Combine';

// 애드익스
import Adex from 'pages/Main/Product/Adex';

// 상품 관리
import RealTimeAdList from 'pages/Main/ProductManagement/RealTimeAdList';
import Translist from 'pages/Main/Product/Translist';
import Collection from 'pages/Main/ProductManagement/Collection';
import MediaScriptManag from 'pages/Main/ProductManagement/MediaScriptManag';
import CampaignManag from 'pages/Main/ProductManagement/CampaignManag';
import CategoryManag from 'pages/Main/ProductManagement/CategoryManag';
import OutOfStockPlacement from 'pages/Main/ProductManagement/OutOfStockPlacement';
import AdProductManag from 'pages/Main/ProductManagement/AdProductManag';
import CustomizedBanner from 'pages/Main/ProductManagement/CustomizedBanner';
import ImgExamination from 'pages/Main/ProductManagement/ImgExamination';
import NewPageSeting from 'pages/Main/ProductManagement/NewPageSeting';
import Creative from 'pages/Main/Product/Creative';

// 통계 보고서
import DailyStatistics from 'pages/Main/Report/DailyStatistics';
import AbusingList from 'pages/Main/Report/AbusingList';
import AdExStatistics from 'pages/Main/Report/AdExStatistics';
import AdvertiserStatistics from 'pages/Main/Report/AdvertiserStatistics';
import ConversionStatistics from 'pages/Main/Report/ConversionStatistics';
import DataCenter from 'pages/Main/Report/DataCenter';
import FrequencyStatistics from 'pages/Main/Report/FrequencyStatistics';
import LocalTargetingStatistics from 'pages/Main/Report/LocalTargetingStatistics';
import MediaSettlementTable from 'pages/Main/Report/MediaSettlementTable';
import MediaStatistics from 'pages/Main/Report/MediaStatistics';
import MediaTotalStatus from 'pages/Main/Report/MediaTotalStatus';
import MonthStatistics from 'pages/Main/Report/MonthStatistics';
import BrowserStatistics from 'pages/Main/Report/BrowserStatistics';
import OpenRTBStatistics from 'pages/Main/Report/OpenRTBStatistics';
import RequestStatistics from 'pages/Main/Report/RequestStatistics';
import ReturnStatistics from 'pages/Main/Report/ReturnStatistics';
import Targeting from 'pages/Main/Report/Targeting';
import TimeExhaustion from 'pages/Main/Report/TimeExhaustion';
import TimeStatistics from 'pages/Main/Report/TimeStatistics';
import CreativeStatistics from 'pages/Main/Report/Creative';
import BudgetGroup from 'pages/Main/Report/Budget';

//키워드센터
import KeywordCenterReport from 'pages/Main/KeywordCenter/Report';
import KeywordCenterStatus from 'pages/Main/KeywordCenter/Status';

// RTB
import FrameRTB from 'pages/Main/RTB/FrameRTB';
import NativeRTB from 'pages/Main/RTB/NativeRTB';
import OpenRTBManage from 'pages/Main/Manage/OpenRTBManageStatistics';

// 매출/정산
import Calculate from 'pages/Main/SalesAndCalculate/Calculate';
import RevenueManag from 'pages/Main/SalesAndCalculate/RevenueManag';
import VirtualAccount from 'pages/Main/SalesAndCalculate/VirtualAccount';
// 보안
import AuthorityManag from 'pages/Main/Security/AuthorityManag';
import Document from 'pages/Main/Security/Document';
import DevServerInfo from 'pages/Main/Security/DevServerInfo';
// import DbSettingDetail from 'pages/Main/Security/DevServerInfo/DbSettingDetail';

//모비피드
import Mobfeed from 'pages/Main/Report/Mobfeed';

//대표님전용 통계

import MasterStatistics from 'pages/Main/Master/Report';

// 광고주전용
import AdverIpBlock from 'pages/Main/Adver/IpBlock';
import AdverPriEprs from 'pages/Main/Adver/priEprs';
import Block from 'pages/Main/Adver/Block';

// 타겟팅별 색상코드
import Secret from 'pages/Main/Secret/index';
import Script from 'pages/Main/Script/index';

import 'styles/globals.scss';
const generateClassName = createGenerateClassName({
  productionPrefix: 'mobonStyle',
});

/**
 * 테마 설정하는 부분
 * (https://material-ui.com/customization/default-theme/ 참고)
 */
const theme = createMuiTheme({
  typography: {
    fontFamily: ['Noto Sans KR', 'sans-serif'].join(','),
    fontWeight: 300,
    button: {
      fontWeight: 300,
    },
    body1: {
      fontWeight: 300,
      fontSize: '13px',
    },
  },
  // z-index 사용 가이드
  // 시작은 10000부터 시작
  // 레이아웃 가로 스크롤 secHorizScroll 15000
  // PopOver 관련 16000
  zIndex: {
    table: {
      default: 20,
      sticky: 21,
      head: 22,
      headFirst: 23,
      scrollbar: 24,
      dimming: 50,
    },
    popper: 100,
    secHorizScroll: 15000,
    tableLoading: 16010,
    popOver: 16000,
    fullScreen: 17000,
    modal: 18000,
    modalPopover: 18010,
    snackbar: 19000,
  },
  button: {
    hover: {
      borderColor: '#c5c5c5',
    },
  },
  palette: {
    action: {
      // hover: 'rgba(245, 0, 87, 0.08)'
    },
    background: {
      header: '#181c27',
    },
    common: {
      white: '#fff',
      black: '#4d4f5c',
      red: '#dc5858',
      blue: '#4781cc',
      gray: '#b3bac8',
      orange: '#ff9d1d',
      green: '#85b74e',
      yellow: '#f3ee51',
      purple: '#934ba8',
      gray2: '#b7b8bd',
      gray3: '#9b9ca4',
      gray4: '#f6f6f9',
      gray5: '#b8bfc1',
      gray6: '#9ba0a2',
      gary7: '#696969',
      selectedGreen: '#eff9e4',
      bgColor: '#f9fafb',
    },
    primary: {
      50: '#e8f5e9',
      100: '#c8e6c9',
      200: '#a5d6a7',
      300: '#81c784',
      400: '#66bb6a',
      500: '#4caf50',
      600: '#43a047',
      700: '#388e3c',
      800: '#2e7d32',
      900: '#1b5e20',
      A100: '#b9f6ca',
      A200: '#69f0ae',
      A400: '#85b74e',
      A700: '#00c853',
      contrastText: 'rgba(0, 0, 0, 0.87)',
      dark: '#388e3c',
      light: '#81c784',
      main: '#85b74e',
      deep: '#79bd2f',
      boxBorder: '#bfe09a',
      boxBG: '#fafdf3',
      inputBG: '#fff',
      error: '#2fa6fa',
      defaultTextSize: '.9em',
      menuColor: '#98a2ab',
      checkBox: '#85b74e',
      mainColor: '#85b74e',
      division: '#e5e8eb',

      // 메인 section 페이지 경로 관련
      breadcrumbs: '#8ea0b3',
      breadcrumbsGreaterThan: '#b9c2c9',
      breadcrumbsAccent: '#565b82',

      delete: '#ff2828',
    },
    tab: {
      headerBg: '#f9fafb',
      headerTextColor: '#9b9ca4',
    },
    secondary: brown,
    secondaryColor: '#4ed1bd',
    graph: {
      color: {
        0: '#2fa6fa',
        1: '#4ed1bd',
        2: '#ff9d1d',
        3: '#bdc2c8',
        4: '#a87fd3',
      },
      key: {
        AD: '#3A1E09',
        CW: '#CE0D0E',
        HU: '#8CA8C5',
        KL: '#E8D3B6',
        RC: '#2499FA',
        RM: '#A8DCDA',
        SA: '#31C1BB',
        SP: '#F34489',
        SR: '#F6C2CF',
        ST: '#721D3A',
        US: '#B5A595',
        UM: '#B2A191',
        CM: '#C59FC6',
        AU: '#FDE440',
        MR: '#F3A742',
        AT: '#47274C',
        PR: '#B7E0B6',
        RU: '#0B3821',
        PU: '#C0C0C0',
        MU: '#C0C0C0',
        MT: '#FA8162',
        TC: '#259A37',
        TV: '#C5CE0F',
        WC: '#EE8632',
        BP: '#ADCC57',
        MC: '#3548AA',
        CH: '#D3226A',
        CR: '#975595',
        WV: '#F7563C',
        MV: '#F3A742',
        TR: '#00B3B7',
        RE: '#C0C0C0',
        WR: '#014558',
        FR: '#17316B',
        MO: '#C0C0C0',
        WP: '#C0C0C0',
        TM: '#C0C0C0',
        HP: '#C0C0C0',
        HV: '#C0C0C0',
        HE: '#C0C0C0',
        HR: '#C0C0C0',
        HM: '#C0C0C0',
        RT: '#C0C0C0',
        PF: '#C0C0C0',
        PA: '#C0C0C0',
        LC: '#50d52a',
        OS: '#C0C0C0',
        TP: '#C0C0C0',
        etc1: '#600F59',
        etc2: '#5C3D21',
      },
      groundColor: '#fafdf3',
    },
    table: {
      cell: {
        default: '#fff',
        active: '#f6f6f9',
        expend: '#d1e5bd',
        child: '#f4f9ef',
        black: '#000',
        red: '#dc5858',
        green: '#6da72e',
        blue: '#4781cc',
        purple: '#934ba8',
        gray: '#7F7F7F',
      },
      headCellBg: '#fcfcff',
      text: '#77787d',
      border: {
        head: '1px solid #efefef',
        body: '1px solid #e4e4e4',
        screen: '1px solid #e5e8eb',
      },
    },
    box: {
      border: '1px solid #e5e8eb',
      secondaryBorderColor: '#e8e9ec',
      radius: '4px',
      labelBg: '#fcfcff',
    },
    text: {
      // primary: '#33691e'
    },
    icon: {
      default: '#8d9ba2',
    },
    trafficLight: {
      red: 'red',
      yellow: 'gold',
      green: 'green',
    },
  },
});

/**
 * 페이지 라우팅
 */
function App(props) {
  const { history, location } = props;
  const { user, menu, locale, portal } = useSelector(
    ({ auth, menu, locale, portal }) => ({
      user: auth.user,
      menu: menu.list,
      locale: locale.locale,
      portal: portal,
    })
  );
  const dispatch = useDispatch();
  let appPortal = portal.portal;

  useEffect(() => {
    if (!!menu) {
      const firstMenukey = menu.keys().next().value;
      const firstMenu = menu.get(firstMenukey);
      let curUrl = firstMenu.menuUrl;

      if (curUrl === null) {
        const firstSubMenukey = firstMenu.subMenu.keys().next().value;
        curUrl = firstMenu.subMenu.get(firstSubMenukey).menuUrl;
      }
      if (location.pathname === '/') {
        // path를 입력하지 않은경우 메뉴의 첫페이지 보여줌
        history.push(curUrl);
      }
    }
    // eslint-disable-next-line
  }, [menu, history, location]);

  const handlePortalClose = (closeIndex) => {
    const idx = appPortal.indexOf(closeIndex);
    appPortal.splice(idx, 1);
    dispatch(delPortal(appPortal));
  };

  const portalComponent = [];
  for (let i = 0; i < appPortal.length; i++) {
    portalComponent[i] = (
      <MyWindowPortal
        key={i}
        url={appPortal[i].url}
        handleUnmount={(e) => handlePortalClose(i)}
        windowFeatures="width=1500,height=700"
      />
    );
  }

  return (
    <div className={locale}>
      <SuccessSnackbar />
      <StylesProvider generateClassName={generateClassName}>
        <ThemeProvider theme={theme}>
          <Switch>
            {/*컴바인 로그인 처리 */}
            {/* <Route path="/combine" component={CombineLogin} /> */}

            {/* 로그인 */}
            <Route path="/login" component={LoginFormContainer} />
            <Route exact path="/findPassword" component={FindPassword} />
            {/* 가입 */}
            <Route exact path="/join" component={Join} />
            <Route path="/join/:userId" component={RegisterSuccess} />
            {/* 매인 */}
            {user === null ? (
              <Redirect to="/login" />
            ) : (
              <Route exact path="/" component={MainTemplate} />
            )}
            <Route path="/members" component={Users} />
            {/* ***** 상품 관리 ***** */}
            <Route path="/product/translist" component={Translist} />
            <Route path="/changeInfo" component={ChangeInfo} />

            {/* 실시간 광고 송출 리스트 */}
            <Route path="/RealTimeAdList" component={RealTimeAdList} />
            <Route path="/product/translist" component={Translist} />
            {/* 상품 정보 수집현황 */}
            <Route path="/product/collection" component={Collection} />
            {/* 소재검수 */}
            <Route path="/manage/creative_check" component={Creative} />

            {/* 외부 연동 매칭 관리 */}
            <Route path="/product/adex" component={Adex} />
            {/* 매체 스크립트 관리 */}
            <Route path="/product/mediascript" component={MediaScriptManag} />
            {/* 캠페인 관리 */}
            <Route path="/product/campaign" component={CampaignManag} />
            {/* 카테고리 관리 */}
            <Route path="/product/category" component={CategoryManag} />
            {/* 품절 배치 관리 */}
            <Route
              path="/product/soloutbatch"
              component={OutOfStockPlacement}
            />
            {/* 광고 상품 관리 */}
            <Route path="/product/adver" component={AdProductManag} />
            {/* 맞춤형 배너 */}
            <Route path="/product/custombanner" component={CustomizedBanner} />
            {/* 이미지 검수 새창으로 연결됨 */}
            <Route path="/ImgExamination" component={ImgExamination} />
            {/* 새창 링크 설정 */}
            <Route path="/product/setlink" component={NewPageSeting} />
            {/* ***** 통계 보고서 ***** */}
            {/* 일자별 통계 */}
            <Route path="/report/daily" component={DailyStatistics} />
            {/* 매체 통계 */}
            <Route path="/report/media" component={MediaStatistics} />
            {/* Open RTB 통계 */}
            <Route path="/report/openrtb" component={OpenRTBStatistics} />
            {/* 월별 통계 */}
            <Route path="/report/month" component={MonthStatistics} />
            {/* 브라우저별 통계 */}
            <Route path="/report/browser" component={BrowserStatistics} />
            {/* 광고주별통계 */}
            <Route path="/report/adver" component={AdvertiserStatistics} />
            {/* 요청수 통계 */}
            <Route path="/report/request" component={RequestStatistics} />
            {/* 애드익스 통합 */}
            <Route path="/report/adex" component={AdExStatistics} />
            {/* 시간대별 소진 */}
            <Route path="/report/timeamt" component={TimeExhaustion} />
            {/* 시간대별 통계 */}
            <Route path="/report/time" component={TimeStatistics} />
            {/* 타겟팅 보고 */}
            <Route path="/report/targeting" component={Targeting} />
            {/* 매체 종합 현황판 */}
            <Route path="/report/mediaboard" component={MediaTotalStatus} />

            {/* 모비피드 */}
            <Route path="/report/mobfeed" component={Mobfeed} />
            <Route
              path="/report/mediasettle"
              component={MediaSettlementTable}
            />
            {/* 데이터 센터 */}
            <Route path="/report/datacenter" component={DataCenter} />
            {/* 프리퀀시 통계 */}
            <Route path="/report/freq" component={FrequencyStatistics} />
            {/* 컨버전 통계 */}
            <Route path="/report/conversion" component={ConversionStatistics} />
            {/* 반송률 통계 */}
            <Route path="/report/retrn" component={ReturnStatistics} />
            {/* 지역타겟팅 통계 */}
            <Route path="/report/local" component={LocalTargetingStatistics} />
            {/* 어뷰징 관리 */}
            <Route path="/report/abusing" component={AbusingList} />
            {/* 크리에이티브 통계 */}
            <Route path="/report/creative" component={CreativeStatistics} />
            {/* 예산 비중도도 */}
            <Route path="/report/budget" component={BudgetGroup} />
            {/* 키워드 센터 */}
            <Route
              path="/keywordcenter/report"
              component={KeywordCenterReport}
            />
            <Route
              path="/keywordcenter/status"
              component={KeywordCenterStatus}
            />
            {/* ***** 매출/정산 ***** */}
            {/* 매출관리 */}
            <Route path="/sales/revenue" component={RevenueManag} />
            {/* 가상계좌 */}
            <Route path="/sales/virtualAccount" component={VirtualAccount} />
            {/* 정산확인 */}
            <Route path="/sales/calculate" component={Calculate} />
            {/* ***** RTB ***** */}
            {/* 프레임 RTB 새창으로 연결됨 */}
            <Route path="/FrameRTB" component={FrameRTB} />
            {/* ***** 시스템 관리 ***** */}
            {/* 개발/서버 정보 */}
            <Route path="/system/server" component={DevServerInfo} />
            {/* <Route
              path="/system/server/db_settingDetail"
              component={DbSettingDetail}
            /> */}
            {/* 권한 관리 */}
            <Route path="/system/auth" component={AuthorityManag} />
            {/* 다큐먼트 */}
            <Route path="/system/document" component={Document} />
            {/* ****************************** */}
            {/* 광고주 통계 */}
            <Route
              path="/AdvertiserStatistics"
              component={AdvertiserStatistics}
            />
            {/* 네이티브 RTB */}
            <Route path="/NativeRTB" component={NativeRTB} />
            {/* Open RTB 관리 */}
            <Route path="/manage/openrtb" component={OpenRTBManage} />
            {/* 대표님전용 통계 */}
            <Route path="/master/report" component={MasterStatistics} />
            {/* 광고주전용 */}
            <Route path="/adver/ip_block" component={AdverIpBlock} />
            <Route path="/adver/priEprs" component={AdverPriEprs} />
            <Route path="/adver/osBlock" component={Block} />

            <Route path="/secret/keysColor" component={Secret} />
            <Route path="/script" component={Script} />

            {/* ***** 404 페이지 ***** */}
            <Route render={() => <div>못찾음</div>} />
          </Switch>
        </ThemeProvider>
      </StylesProvider>
      {appPortal.length !== 0 &&
        //sudo App.js 로 빼야할지 고민 다른탭 이동하면 사라지므로
        appPortal.map((index) => {
          return portalComponent[index.cnt];
        })}
    </div>
  );
}

export default withRouter(App);
